export const base64Image = (image: string): string => {
  return `data:image/png;base64, ${image}`;
};
